export const EXCHANGE_RATE_LIST_ACTION = "EXCHANGE_RATE_LIST_ACTION";
export const EXCHANGE_RATE_LIST_SUCCESS = "EXCHANGE_RATE_LIST_SUCCESS";
export const EXCHANGE_RATE_UPDATE_ACTION = "EXCHANGE_RATE_UPDATE_ACTION";
export const EXCHANGE_RATE_UPDATE_SUCCESS = "EXCHANGE_RATE_UPDATE_SUCCESS";
export const EXCHANGE_RATE_FAIL = "EXCHANGE_RATE_FAIL";